import { render, staticRenderFns } from "./SamplesFilter.vue?vue&type=template&id=19ed3cd3&scoped=true"
import script from "./SamplesFilter.vue?vue&type=script&lang=js"
export * from "./SamplesFilter.vue?vue&type=script&lang=js"
import style0 from "./SamplesFilter.vue?vue&type=style&index=0&id=19ed3cd3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ed3cd3",
  null
  
)

export default component.exports